/* ============================================================
   Vector Tracing Pro — Quote Page JS
   File: assets/get-a-quote.js
   ============================================================ */

(function () {
  'use strict';

  /* ── File upload zone ── */
  var dropzone = document.getElementById('gaqDropzone');
  var fileInput = document.getElementById('gaqFile');
  var fileName  = document.getElementById('gaqFileName');

  if (dropzone && fileInput) {
    dropzone.addEventListener('click', function () {
      fileInput.click();
    });

    dropzone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fileInput.click();
      }
    });

    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files[0]) {
        showFileName(fileInput.files[0].name);
      }
    });

    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('gaq-dragover');
    });

    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('gaq-dragover');
    });

    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('gaq-dragover');
      var files = e.dataTransfer.files;
      if (files && files[0]) {
        fileInput.files = files;
        showFileName(files[0].name);
      }
    });

    function showFileName(name) {
      if (fileName) {
        document.getElementById('gaqFileNameText').textContent = '✓ ' + name;
        fileName.removeAttribute('hidden');
      }
    }

    /* ── Remove file button ── */
    var removeBtn = document.getElementById('gaqFileRemove');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        fileInput.value = '';
        document.getElementById('gaqFileNameText').textContent = '';
        fileName.setAttribute('hidden', '');
      });
    }
  }
  /* ── Service chip toggling ── */
  // var chips = document.querySelectorAll('.gaq-chip');
  // chips.forEach(function (chip) {
  //   var radio = chip.querySelector('.gaq-chip__radio');
  //   if (!radio) return;

  //   chip.addEventListener('click', function () {
  //     chips.forEach(function (c) { c.classList.remove('gaq-chip--selected'); });
  //     chip.classList.add('gaq-chip--selected');
  //     radio.checked = true;
  //   });
  // });

 var chips = document.querySelectorAll('.gaq-chip');
chips.forEach(function (chip) {
  var checkbox = chip.querySelector('.gaq-chip__radio');
  if (!checkbox) return;

  chip.addEventListener('click', function () {
    chip.classList.toggle('gaq-chip--selected');
    checkbox.checked = !checkbox.checked;
  });
});;

  /* ── Format tag toggling ── */
  var ftags = document.querySelectorAll('.gaq-ftag');
  ftags.forEach(function (tag) {
    var checkbox = tag.querySelector('.gaq-ftag__check');
    if (!checkbox) return;

    tag.addEventListener('click', function () {
      tag.classList.toggle('gaq-ftag--sel');
    });
  });

  /* ── Rush button toggling ── */
  var rbtns = document.querySelectorAll('.gaq-rbtn');
  rbtns.forEach(function (btn) {
    var radio = btn.querySelector('.gaq-rbtn__radio');
    if (!radio) return;

    btn.addEventListener('click', function () {
      rbtns.forEach(function (b) { b.classList.remove('gaq-rbtn--active'); });
      btn.classList.add('gaq-rbtn--active');
      radio.checked = true;
    });
  });

  /* ── Basic client-side validation ── */
  var form = document.getElementById('gaq-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var name  = document.getElementById('gaqName');
      var email = document.getElementById('gaqEmail');
      var errors = [];

      if (name && !name.value.trim()) {
        errors.push('Please enter your name.');
        name.focus();
      }

      if (email && !isValidEmail(email.value.trim())) {
        errors.push('Please enter a valid email address.');
        if (!errors.length) email.focus();
      }

      if (errors.length) {
        e.preventDefault();
        var existing = form.querySelector('.gaq-client-error');
        if (existing) existing.remove();

        var errDiv = document.createElement('div');
        errDiv.className = 'gaq-error gaq-client-error';
        errDiv.setAttribute('role', 'alert');
        errDiv.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
          '<div><strong>Please fix the following:</strong><ul style="margin:4px 0 0 16px;font-size:13px">' +
          errors.map(function (e) { return '<li>' + e + '</li>'; }).join('') +
          '</ul></div>';

        form.insertBefore(errDiv, form.querySelector('.gaq-submit-btn'));
        errDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  /* ── Scroll-reveal: sidebar cards fade in ── */
  if ('IntersectionObserver' in window) {
    var cards = document.querySelectorAll('.gaq-s-card, .gaq-form-card');
    cards.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(12px)';
      el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    cards.forEach(function (el) { observer.observe(el); });
  }

})();
